import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import LandingHeader from "../components/LandingHeader";
import LandingFooter from "../components/LandingFooter";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>5 Business Habits Guide - courtesy of Elm Street</title>
        <meta
          name="description"
          content="This guide will give you 5 strategies to promote better habits that will help you progress through your real estate business goals for 2023."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/5businesshabits" />
        <meta property="og:title" content="5 Business Habits Guide - courtesy of Elm Street" />
        <meta
          property="og:description"
          content="This guide will give you 5 strategies to promote better habits that will help you progress through your real estate business goals for 2023."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />

      <LandingHeader />

      <div
        style={{
          backgroundImage: "url('esbg3.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h2" component="h1" style={{ color: "#ffffff" }}>
                  <span style={{ color: "#f69c26" }}>
                  5 STRATEGIES <br /><span style={{ color: "#ffffff" }}>FOR YOU TO CREATE<br />
                  BETTER BUSINESS HABITS</span>
                  </span>
                  
                </Typography>
                <br />
                <span style={{ color: "#ffffff" }}>
                  
                To develop successful habits, remove the emphasis on the end goal and hone in on the process itself. This guide will give you 5 strategies to promote better habits that will help you progress through your real estate business goals for 2023. 
                </span>
              </Grid>
              <Grid item md={6} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image src="/5strategies.jpg" width="700px" height="892px" alt="5 Business Habits Guide"/>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ textAlign: "left" }}>
        <div style={{ marginTop: "68px", marginBottom: "68px" }}>
          <Grid container spacing={8} justifyContent="center">
            <Grid item md={8}>
            <DemoForm
              buttonText="Download Now"
              successMsg={<div style={{textAlign:"center"}}><strong>Thank you for your interest!</strong><br/><br/><Button variant="contained" color="secondary" href="/assets/5-strategies-better-business-habits.pdf">Download the PDF</Button></div>}
              formName="es2_5businesshabits" listId="154369"
              fieldList={["first_name", "last_name", "email", "phone", "roll"]}
            />
            </Grid>
          </Grid>
        </div>
      </Container>

      <LandingFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
